import client from './api-client';

export const getConfiguracionForm14 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form14: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGestionImpicado = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestionImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboRegistrarHito = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboRegistrarHitos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const actualizarProcesoExtrajudicial = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/contacto', file);
       
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaExtrajudicial: response.data};
        } else {
            return {respuestaExtrajudicial: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const getListaImplicado = async(query) => {
    try {
        
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}